module.exports = __webpack_public_path__ + "img/door-close.b24ab99e.gif";